import React from "react";

import "./styles.scss";

type StepperProps = {
  steps: string[];
  currentStep: number; // 1-based
};

export const Stepper: React.FC<StepperProps> = ({ steps, currentStep }: StepperProps) => (
  <nav className="Stepper" aria-label="Progress steps">
    {steps.map((label: string, index: number) => {
      const stepNumber: number = index + 1;
      const isCompleted: boolean = stepNumber < currentStep;
      const isCurrent: boolean = stepNumber === currentStep;

      let modifier: string = "";
      if (isCompleted) modifier = "Stepper__item--completed";
      else if (isCurrent) modifier = "Stepper__item--current";

      return (
        <div key={label} className={`Stepper__item ${modifier}`}>
          {index > 0 && <div className="Stepper__line" aria-hidden="true" />}
          <div className="Stepper__circle" aria-hidden="true">
            {isCompleted && (
              <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 5L4.5 8.5L11 1.5"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>
          <span className="Stepper__label" aria-current={isCurrent ? "step" : undefined}>
            {label}
          </span>
        </div>
      );
    })}
  </nav>
);
